import React, { useState, useEffect } from "react";
import Container from '@mui/material/Container';
import { Alert, Button, FormControl, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import axios from "axios";
import Loadingspinner from "../../../components/Loadingspinner";
import { Fetchaccountsurl, Fetchpartnerrequestsurl } from "../../../utils/chaturls";
import { getsessionuser } from "../../../utils/sessions";
import { primarycolor } from "../../../utils/colors";
import Partnermessage from "./partnermessage";

const tableheadstyle = {
    color: "white",
    fontWeight: "bold"
}



const Partners = () => {

    const user = getsessionuser();
    const [partners, setpartners] = useState([]);
    const [displayedpartners, setdisplayedpartners] = useState([]);

    const [loading, setloading] = useState(true);
    const [error, seterror] = useState('');
    const [success, setsuccess] = useState('');


    const [partneremail, setpartneremail] = useState('');

    useEffect(() => {
        fetchpartners()
    }, []);





    const fetchpartners = async () => {
        setloading(true)
        axios.post(Fetchpartnerrequestsurl)
            .then(response => {
                setloading(false)
                if (!response.data.error) {
                    setpartners(response.data)
                    setdisplayedpartners(response.data)
                } else {
                    seterror(response.data.message)
                }
                // 
            }).catch(error => {
                setloading(false)
                seterror("Sorry an error occurred,try again later");
            });
    }


    const Searchlogic = () => {
        return partners.filter(element => {
            if (partneremail) {
                const sanitizedSearch = partneremail.toLowerCase().replace(/\s+/g, '');
                const elementEmail = element.email?.toLowerCase().replace(/\s+/g, '');
                return elementEmail?.includes(sanitizedSearch);
            }
            return false;
        });
    }

    const searchpartners = () => {
        if (!partneremail) {
            setdisplayedpartners(partners);
        } else {
            const gottendata = Searchlogic();
            if (gottendata.length > 0) {
                setdisplayedpartners(gottendata);
            } else {
                setdisplayedpartners([]);
                seterror("No requests match the search query");
            }
        }
    }

    const cellfontsize = 15


    return (
        <div>
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => seterror()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <Snackbar open={success?.length > 0 && true} autoHideDuration={3000} onClose={() => setsuccess()}>
                <Alert severity="success">{success}</Alert>
            </Snackbar>
            {loading && <Loadingspinner />}

            <div className="routepathwrap">
                <div className="routepathmain">Partners </div>
                <div className="routepathminor"> {` `}/ Partner requests</div>
            </div>

            <Container maxWidth="lg" className="containerwithshadow">
                <div style={{ display: "flex" }}>
                    <TextField
                        id="outlined-basic"
                        value={partneremail}
                        onChange={(e) => setpartneremail(e.target.value)}
                        sx={{ maxHeight: 25, marginRight: 10 }}
                        label="Name"
                        variant="outlined"
                        size="small" />
                    <FormControl sx={{ m: 1, minWidth: 200, marginRight: 10 }}>

                    </FormControl>
                    <Button variant="contained" onClick={() => searchpartners()} sx={{ height: 40 }}>Search</Button>
                </div>
            </Container>
            <Container maxWidth="lg" className="containerwith" style={{ marginTop: 20 }}>
                <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead sx={{ backgroundColor: primarycolor }}>
                            <TableRow>
                                <TableCell sx={tableheadstyle}>ID </TableCell>
                                <TableCell sx={tableheadstyle} >Bsn Name</TableCell>
                                <TableCell sx={tableheadstyle} >Name</TableCell>
                                <TableCell sx={tableheadstyle} >Tel</TableCell>
                                <TableCell sx={tableheadstyle} >Email</TableCell>
                                <TableCell sx={tableheadstyle} >County</TableCell>
                                <TableCell sx={tableheadstyle} >city</TableCell>
                                <TableCell sx={tableheadstyle} >Role</TableCell>
                                <TableCell sx={tableheadstyle} >Mode</TableCell>
                                <TableCell sx={tableheadstyle} >Message</TableCell>
                                <TableCell sx={tableheadstyle} >Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayedpartners?.length > 0 && displayedpartners?.map((row) => (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell sx={{ display: "flex", position: "relative" }}> {row.id}</TableCell>
                                    <TableCell component="th" scope="row" sx={{ fontSize: 12 }}> {row.businessname}  </TableCell>
                                    <TableCell component="th" scope="row" sx={{ fontSize: 12 }}> {row.fullname}  </TableCell>
                                    <TableCell sx={{ fontSize: cellfontsize }}>{row.phone}</TableCell>
                                    <TableCell sx={{ fontSize: cellfontsize }}>{row.email}</TableCell>
                                    <TableCell sx={{ fontSize: cellfontsize }}>{row.county}</TableCell>
                                    <TableCell sx={{ fontSize: cellfontsize }}>{row.city}</TableCell>
                                    <TableCell sx={{ fontSize: cellfontsize }}>{row.partnerrole}</TableCell>
                                    <TableCell sx={{ fontSize: cellfontsize }}>{row.howfound}</TableCell>
                                    <TableCell sx={{ fontSize: cellfontsize }}> <Partnermessage message={row.message} /></TableCell>
                                    <TableCell sx={{ fontSize: cellfontsize }}>{new Date(row.created_at).toDateString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Container>
        </div>
    )
}

export default Partners